unit Login;
{

/* Initial. */

}
interface

uses
  SysUtils, Classes, DateUtils, StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, WEBLib.Buttons, WEBLib.Menus,
  WEBLib.StdCtrls, BaseResponse, Client, Config, LanguageTerm, LanguageTermList, TermListGetResponse, TermListGetRequest, Utils;

type
  TForm_Login = class(TForm)
    WebPanel_Header: TPanel;
    WebMainMenu_Language: TMainMenu;
    WebImageControl_Logo: TImageControl;
    WebPanel_Login: TPanel;
    WebLabel_LoginName: TLabel;
    WebLabel_PassWord: TLabel;
    WebEdit_LoginName: TEdit;
    WebEdit_PassWord: TEdit;
    WebBitBtn_Login: TBitBtn;
    WebBitBtn_Quit: TBitBtn;
    WebTimer_Login: TTimer;
    WebLabel_Time: TLabel;
    MenuItem_Language: TMenuItem;
    Dutch1: TMenuItem;
    English1: TMenuItem;
    Spanish1: TMenuItem;
    procedure WebBitBtn_QuitClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebMenuItem_LanguageClick(Sender: TObject);
    procedure WebTimer_LoginTimer(Sender: TObject);
  private
    Boolean_Quit: Boolean;
    procedure InitLanguageTerms;
    procedure Quit;
    procedure RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form_Login: TForm_Login;
  RestClient: TClient;

implementation


procedure TForm_Login.WebBitBtn_QuitClick(Sender: TObject);
begin
  Close;
end;

procedure TForm_Login.WebFormCreate(Sender: TObject);
begin
  WebPanel_Header.Color := GetColor('Panel_Header');
  WebPanel_Login.Color := GetColor('Panel_Header');
end;

procedure TForm_Login.WebFormResize(Sender: TObject);
begin
  WebLabel_Time.Left := ClientWidth div 2;
  WebPanel_Login.Left := (ClientWidth div 2) - WebPanel_Login.Width div 2;
  WebPanel_Login.Top := (ClientHeight div 2) - WebPanel_Login.Height div 2;
  WebImageControl_Logo.Top := ClientHeight - WebImageControl_Logo.Height;
end;

procedure TForm_Login.WebFormShow(Sender: TObject);
begin
  InitLanguageTerms;

  WebEdit_LoginName.Text := '';
  WebEdit_PassWord.Text := '';

  Form_Login.Height := ClientHeight;
end;

procedure TForm_Login.WebMenuItem_LanguageClick(Sender: TObject);
var
  TermListGetRequest: TTermListGetRequest;
  String_Caption: String;
  String_Language: String;
begin
  String_Caption := (Sender as TMenuItem).Caption;

  String_Language := LanguageTermList_Language.GetCodeOnLanguageTerm(String_Caption);

  RestClient := TClient.Create('ERBASOFT', 'Es637485!');
  RestClient.OnResult := RestClientOnResult;

  TermListGetRequest := TTermListGetRequest.Create('Debug', String_Language, 0);

  RestClient.Call('/term/listget', TermListGetRequest, True);

  TermListGetRequest.Free;
end;

procedure TForm_Login.WebTimer_LoginTimer(Sender: TObject);
var Time_Now: TTime;
    String_Time: String;
begin
  Time_Now := Time();

  if (CompareTime(Time_Now, EncodeTime(06, 59, 59, 99)) > 0) and (CompareTime(Time_Now, EncodeTime(12, 00, 00, 00)) < 0) then
    String_Time := LanguageTermList_Language.GoodMorning
  else if (CompareTime(Time_Now, EncodeTime(11, 59, 59, 99)) > 0) and (CompareTime(Time_Now, EncodeTime(18, 00, 00, 00)) < 0) then
    String_Time := LanguageTermList_Language.GoodAfternoon
  else if (CompareTime(Time_Now, EncodeTime(17, 59, 59, 99)) > 0) and  (CompareTime(Time_Now, EncodeTime(23, 59, 59, 99)) <= 0) then
    String_Time := LanguageTermList_Language.GoodEvening
  else
    String_Time := LanguageTermList_Language.GoodNight;

  // Stub for now to show which IRIS server is used.
  if Pos('9092', String_Server) > 0 then
    WebLabel_Time.Caption := String_Time + ': ' + FormatDateTime('hh:nn:ss', Time_Now) + ' (O)'
  else if Pos('9094', String_Server) > 0 then
    WebLabel_Time.Caption := String_Time + ': ' + FormatDateTime('hh:nn:ss', Time_Now) + ' (T)'
  else
    WebLabel_Time.Caption := String_Time + ': ' + FormatDateTime('hh:nn:ss', Time_Now)
end;

procedure TForm_Login.InitLanguageTerms;
var
  Array_LanguageTerms: array of String;
  MenuItem_SubLanguage: TMenuItem;
  Guid: TGuid;
  Word_Language: Word;
  Byte_MenuItem: Byte;
begin
  WebMainMenu_Language.Visible := false;

  // MenuItem_Language.Clear doesn't work.
  for Word_Language := MenuItem_Language.Items.Count - 1 downto 0  do
  begin
    MenuItem_Language.Items.Delete(Word_Language);
  end;

  WebLabel_LoginName.Caption := LanguageTermList_Language.GetLanguageTerm('Login name');
  WebLabel_Password.Caption := LanguageTermList_Language.GetLanguageTerm('Password');
  WebBitBtn_Login.Caption := LanguageTermList_Language.GetLanguageTerm('Login');
  WebBitBtn_Quit.Caption := LanguageTermList_Language.GetLanguageTerm('Quit');
  MenuItem_Language.Caption := LanguageTermList_Language.GetLanguageTerm('Language');

  Array_LanguageTerms := LanguageTermList_Language.GetLanguageTermsOnMemberOf('Language');

  for Word_Language := 0 to Length(Array_LanguageTerms) - 1 do
  begin
    CreateGUID(Guid);

    MenuItem_SubLanguage := TMenuItem.Create(Self);

    MenuItem_SubLanguage.Caption := Array_LanguageTerms[Word_Language];

    // Create unique name;
    Byte_MenuItem := 0;
    Repeat
      Byte_MenuItem := Byte_MenuItem + 1;
    Until (Self.FindComponent('MenuItem_' + IntToStr(Byte_MenuItem)) = nil);

    MenuItem_SubLanguage.Name := 'MenuItem_' + IntToStr(Byte_MenuItem);
    MenuItem_SubLanguage.OnClick := WebMenuItem_LanguageClick;

    MenuItem_Language.Items.Add(MenuItem_SubLanguage);
  end;

  WebMainMenu_Language.Visible := True;

  SetLength(Array_LanguageTerms, 0);
end;

procedure TForm_Login.Quit;
begin
  ShowMessage(LanguageTermList_Language.GetLanguageTermOnCode('ServerCommunicationError'));

  Close;
end;

procedure TForm_Login.RestClientOnResult(BaseResponse: TBaseResponse; const Boolean_Error: Boolean);
var Boolean_LoadTerms: Boolean;
    TermListGetResponse: TTermListGetResponse;
begin
  RestClient.Free;

  if not Boolean_Error then
  begin
    TermListGetResponse := BaseResponse as TTermListGetResponse;

    Boolean_LoadTerms := LanguageTermList_Language.LoadLanguageTerms(TermListGetResponse);

    TermListGetResponse.Free;

    if Boolean_LoadTerms then
    begin
      InitLanguageTerms;

      WebEdit_LoginName.Text := '';
      WebEdit_PassWord.Text := '';
    end
    else
      ShowMessage('LoadTermsError');
  end
  else
    ShowMessage('Error');
end;

procedure TForm_Login.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl_Logo := TImageControl.Create(Self);
  WebPanel_Header := TPanel.Create(Self);
  WebLabel_Time := TLabel.Create(Self);
  WebPanel_Login := TPanel.Create(Self);
  WebLabel_LoginName := TLabel.Create(Self);
  WebLabel_PassWord := TLabel.Create(Self);
  WebEdit_LoginName := TEdit.Create(Self);
  WebEdit_PassWord := TEdit.Create(Self);
  WebBitBtn_Login := TBitBtn.Create(Self);
  WebBitBtn_Quit := TBitBtn.Create(Self);
  WebMainMenu_Language := TMainMenu.Create(Self);
  MenuItem_Language := TMenuItem.Create(Self);
  Dutch1 := TMenuItem.Create(Self);
  English1 := TMenuItem.Create(Self);
  Spanish1 := TMenuItem.Create(Self);
  WebTimer_Login := TTimer.Create(Self);

  WebImageControl_Logo.BeforeLoadDFMValues;
  WebPanel_Header.BeforeLoadDFMValues;
  WebLabel_Time.BeforeLoadDFMValues;
  WebPanel_Login.BeforeLoadDFMValues;
  WebLabel_LoginName.BeforeLoadDFMValues;
  WebLabel_PassWord.BeforeLoadDFMValues;
  WebEdit_LoginName.BeforeLoadDFMValues;
  WebEdit_PassWord.BeforeLoadDFMValues;
  WebBitBtn_Login.BeforeLoadDFMValues;
  WebBitBtn_Quit.BeforeLoadDFMValues;
  WebMainMenu_Language.BeforeLoadDFMValues;
  MenuItem_Language.BeforeLoadDFMValues;
  Dutch1.BeforeLoadDFMValues;
  English1.BeforeLoadDFMValues;
  Spanish1.BeforeLoadDFMValues;
  WebTimer_Login.BeforeLoadDFMValues;
  try
    Name := 'Form_Login';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Arial';
    Font.Style := [];
    Menu := WebMainMenu_Language;
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebImageControl_Logo.SetParentComponent(Self);
    WebImageControl_Logo.Name := 'WebImageControl_Logo';
    WebImageControl_Logo.Left := 8;
    WebImageControl_Logo.Top := 323;
    WebImageControl_Logo.Width := 233;
    WebImageControl_Logo.Height := 149;
    WebImageControl_Logo.Align := alCustom;
    WebImageControl_Logo.Anchors := [akLeft,akBottom];
    WebImageControl_Logo.AutoSize := True;
    WebImageControl_Logo.ChildOrder := 1;
    WebImageControl_Logo.Picture.LoadFromFile('Login.WebImageControl_Logo.Picture.bmp');
    WebPanel_Header.SetParentComponent(Self);
    WebPanel_Header.Name := 'WebPanel_Header';
    WebPanel_Header.Left := 0;
    WebPanel_Header.Top := 0;
    WebPanel_Header.Width := 640;
    WebPanel_Header.Height := 100;
    WebPanel_Header.Align := alTop;
    WebPanel_Header.BorderColor := clSilver;
    WebPanel_Header.BorderStyle := bsNone;
    WebPanel_Header.Caption := 'WebPanel_Header';
    WebPanel_Header.ShowCaption := False;
    WebLabel_Time.SetParentComponent(WebPanel_Header);
    WebLabel_Time.Name := 'WebLabel_Time';
    WebLabel_Time.Left := 528;
    WebLabel_Time.Top := 32;
    WebLabel_Time.Width := 73;
    WebLabel_Time.Height := 22;
    WebLabel_Time.Caption := 'Welkom';
    WebLabel_Time.Font.Charset := DEFAULT_CHARSET;
    WebLabel_Time.Font.Color := clWhite;
    WebLabel_Time.Font.Height := -19;
    WebLabel_Time.Font.Name := 'Arial';
    WebLabel_Time.Font.Style := [fsBold];
    WebLabel_Time.ParentFont := False;
    WebPanel_Login.SetParentComponent(Self);
    WebPanel_Login.Name := 'WebPanel_Login';
    WebPanel_Login.Left := 128;
    WebPanel_Login.Top := 164;
    WebPanel_Login.Width := 385;
    WebPanel_Login.Height := 153;
    WebPanel_Login.Align := alCustom;
    WebPanel_Login.Anchors := [akTop];
    WebPanel_Login.BorderColor := clSilver;
    WebPanel_Login.BorderStyle := bsNone;
    WebPanel_Login.ChildOrder := 2;
    WebPanel_Login.Font.Charset := DEFAULT_CHARSET;
    WebPanel_Login.Font.Color := clWindowText;
    WebPanel_Login.Font.Height := -13;
    WebPanel_Login.Font.Name := 'Arial';
    WebPanel_Login.Font.Style := [];
    WebPanel_Login.ParentFont := False;
    WebPanel_Login.ShowCaption := False;
    WebLabel_LoginName.SetParentComponent(WebPanel_Login);
    WebLabel_LoginName.Name := 'WebLabel_LoginName';
    WebLabel_LoginName.Left := 24;
    WebLabel_LoginName.Top := 24;
    WebLabel_LoginName.Width := 180;
    WebLabel_LoginName.Height := 16;
    WebLabel_LoginName.Caption := 'Login name';
    WebLabel_LoginName.Font.Charset := DEFAULT_CHARSET;
    WebLabel_LoginName.Font.Color := clWindowText;
    WebLabel_LoginName.Font.Height := -13;
    WebLabel_LoginName.Font.Name := 'Arial';
    WebLabel_LoginName.Font.Style := [];
    WebLabel_LoginName.ParentFont := False;
    WebLabel_PassWord.SetParentComponent(WebPanel_Login);
    WebLabel_PassWord.Name := 'WebLabel_PassWord';
    WebLabel_PassWord.Left := 24;
    WebLabel_PassWord.Top := 61;
    WebLabel_PassWord.Width := 180;
    WebLabel_PassWord.Height := 16;
    WebLabel_PassWord.Caption := 'Password';
    WebLabel_PassWord.Font.Charset := DEFAULT_CHARSET;
    WebLabel_PassWord.Font.Color := clWindowText;
    WebLabel_PassWord.Font.Height := -13;
    WebLabel_PassWord.Font.Name := 'Arial';
    WebLabel_PassWord.Font.Style := [];
    WebLabel_PassWord.ParentFont := False;
    WebEdit_LoginName.SetParentComponent(WebPanel_Login);
    WebEdit_LoginName.Name := 'WebEdit_LoginName';
    WebEdit_LoginName.Left := 210;
    WebEdit_LoginName.Top := 23;
    WebEdit_LoginName.Width := 150;
    WebEdit_LoginName.Height := 22;
    WebEdit_LoginName.ChildOrder := 2;
    WebEdit_PassWord.SetParentComponent(WebPanel_Login);
    WebEdit_PassWord.Name := 'WebEdit_PassWord';
    WebEdit_PassWord.Left := 210;
    WebEdit_PassWord.Top := 60;
    WebEdit_PassWord.Width := 150;
    WebEdit_PassWord.Height := 22;
    WebEdit_PassWord.ChildOrder := 3;
    WebEdit_PassWord.PasswordChar := '*';
    WebBitBtn_Login.SetParentComponent(WebPanel_Login);
    WebBitBtn_Login.Name := 'WebBitBtn_Login';
    WebBitBtn_Login.Left := 49;
    WebBitBtn_Login.Top := 104;
    WebBitBtn_Login.Width := 96;
    WebBitBtn_Login.Height := 25;
    WebBitBtn_Login.Caption := 'Login';
    WebBitBtn_Login.Color := clNone;
    WebBitBtn_Login.TabOrder := 2;
    WebBitBtn_Quit.SetParentComponent(WebPanel_Login);
    WebBitBtn_Quit.Name := 'WebBitBtn_Quit';
    WebBitBtn_Quit.Left := 240;
    WebBitBtn_Quit.Top := 104;
    WebBitBtn_Quit.Width := 96;
    WebBitBtn_Quit.Height := 25;
    WebBitBtn_Quit.Caption := 'Quit';
    WebBitBtn_Quit.Color := clNone;
    WebBitBtn_Quit.TabOrder := 3;
    SetEvent(WebBitBtn_Quit, Self, 'OnClick', 'WebBitBtn_QuitClick');
    WebMainMenu_Language.SetParentComponent(Self);
    WebMainMenu_Language.Name := 'WebMainMenu_Language';
    WebMainMenu_Language.Appearance.HamburgerMenu.Caption := 'Menu';
    WebMainMenu_Language.Appearance.SubmenuIndicator := '&#9658;';
    WebMainMenu_Language.Visible := False;
    WebMainMenu_Language.Left := 24;
    WebMainMenu_Language.Top := 16;
    MenuItem_Language.SetParentComponent(WebMainMenu_Language);
    MenuItem_Language.Name := 'MenuItem_Language';
    MenuItem_Language.Caption := 'Language';
    Dutch1.SetParentComponent(MenuItem_Language);
    Dutch1.Name := 'Dutch1';
    Dutch1.Caption := 'Dutch';
    English1.SetParentComponent(MenuItem_Language);
    English1.Name := 'English1';
    English1.Caption := 'English';
    Spanish1.SetParentComponent(MenuItem_Language);
    Spanish1.Name := 'Spanish1';
    Spanish1.Caption := 'Spanish';
    WebTimer_Login.SetParentComponent(Self);
    WebTimer_Login.Name := 'WebTimer_Login';
    WebTimer_Login.Enabled := True;
    SetEvent(WebTimer_Login, Self, 'OnTimer', 'WebTimer_LoginTimer');
    WebTimer_Login.Left := 136;
    WebTimer_Login.Top := 16;
  finally
    WebImageControl_Logo.AfterLoadDFMValues;
    WebPanel_Header.AfterLoadDFMValues;
    WebLabel_Time.AfterLoadDFMValues;
    WebPanel_Login.AfterLoadDFMValues;
    WebLabel_LoginName.AfterLoadDFMValues;
    WebLabel_PassWord.AfterLoadDFMValues;
    WebEdit_LoginName.AfterLoadDFMValues;
    WebEdit_PassWord.AfterLoadDFMValues;
    WebBitBtn_Login.AfterLoadDFMValues;
    WebBitBtn_Quit.AfterLoadDFMValues;
    WebMainMenu_Language.AfterLoadDFMValues;
    MenuItem_Language.AfterLoadDFMValues;
    Dutch1.AfterLoadDFMValues;
    English1.AfterLoadDFMValues;
    Spanish1.AfterLoadDFMValues;
    WebTimer_Login.AfterLoadDFMValues;
  end;
end;

end.
